/* component-collection-desc.js — read-more collapse for collection description.
 * Loaded conditionally when the description row has read-more enabled.
 * J12 IIFE-dedup: guarded by window.__kvCollectionDesc. */
(function () {
  if (window.__kvCollectionDesc) return;
  window.__kvCollectionDesc = true;

  function init() {
    var containers = document.querySelectorAll('[data-collection-desc-body]');
    containers.forEach(function (body) {
      var wrapper = body.closest('.collection-desc--has-readmore');
      if (!wrapper) return;
      /* Idempotence marker. init() re-runs over the WHOLE document after a
         filter update, so an already-processed wrapper must be skipped — a
         second pass would bind a second click listener to the same toggle
         (two toggles per click = no visible change). Freshly-swapped nodes
         arrive unmarked and get measured + clamped normally. */
      if (wrapper.hasAttribute('data-cd-init')) return;
      var toggle = wrapper.querySelector('[data-collection-desc-toggle]');
      if (!toggle) return;
      wrapper.setAttribute('data-cd-init', '');

      var collapseHeight = parseInt(
        getComputedStyle(body).getPropertyValue('--cd-collapse-height'), 10
      ) || 80;

      if (body.scrollHeight <= collapseHeight) {
        /* Content fits — no clamping needed, keep toggle hidden. */
        return;
      }

      /* Content overflows — clamp and show toggle. */
      body.classList.add('is-clamped');
      toggle.hidden = false;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.textContent = toggle.getAttribute('data-label-more');

      toggle.addEventListener('click', function () {
        var clamped = body.classList.toggle('is-clamped');
        toggle.setAttribute('aria-expanded', String(!clamped));
        toggle.textContent = clamped
          ? toggle.getAttribute('data-label-more')
          : toggle.getAttribute('data-label-less');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Re-init after a no-reload filter/sort/pagination update. The description
     renders INSIDE #CollectionResults, which component-collection-facets.js
     replaces wholesale on every update — taking .is-clamped, the toggle's
     hidden=false and its click listener with it. The facets engine dispatches
     this once per completed update (back/forward included); init() is
     idempotent via data-cd-init, so this only touches the new nodes. */
  document.addEventListener('collection:results-updated', init);
})();
